<template>
  <VDialog v-model="visivel" max-width="300px" :persistent="true">
    <template v-slot:activator="{ on }">
      <VBtn v-if="descontoValorTotal" :disabled="disabled" v-on="on"
        >Aplicar desconto</VBtn
      >

      <VLayout v-if="descontoUnitario">
        <VTooltip bottom>
          <VBtn
            v-on="on"
            slot="activator"
            color="primary"
            icon
            flat
            :disabled="disabledDescontoUnitario"
            small
          >
            <VIcon> label_off </VIcon>
          </VBtn>
          Desconto unitário
        </VTooltip>
      </VLayout>
    </template>
    <VCard>
      <VCardTitle
        ><span class="headline"> {{ labelTitle }} </span></VCardTitle
      >
      <VCardText>
        <VRadioGroup v-model="nomeTipoDesconto" @change="fator = 0">
          <VRadio
            v-for="t in tipos"
            :key="t.nome"
            :label="t.label"
            :value="t.nome"
          />
        </VRadioGroup>
        <VForm ref="form">
          <v-currency-field
            :label="tipoDesconto.labelFator"
            ref="quantia"
            :rules="tipoDesconto.regras"
            v-bind="tipoDesconto.mascara"
            v-model="fator"
          />
        </VForm>
      </VCardText>
      <VCardActions>
        <VBtn @click="aplicarDesconto">Aplicar</VBtn>
        <VBtn @click="visivel = false">Cancelar</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import forms from "@/common/forms";
import alerts from "@/common/alerts";

export default {
  name: "DescontoDialog",

  data() {
    return {
      fator: 0,
      visivel: false,
      nomeTipoDesconto: "Percentual",
    };
  },

  props: {
    descontoValorTotal: {
      type: Boolean,
      default: true,
    },

    descontoUnitario: {
      type: Boolean,
      default: false,
    },

    item: {
      type: Object,
    },

    valorTotal: {
      type: Number,
      default: 0,
    },

    desconto: {
      type: Object,
      default: () => {
        return {
          tipo: "Percentual",
          valor: 0,
        };
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    disabledDescontoUnitario: {
      type: Boolean,
      default: false,
    },

    limiteDesconto: {
      type: Number,
    },

    labelTitle: {
      type: String,
      default: "Desconto",
    },
  },
  watch: {
    desconto: {
      handler(desconto) {
        if (desconto && desconto.tipo != 'SemDesconto') {
          this.nomeTipoDesconto = desconto.tipo;
          this.fator =
            desconto.tipo === "Percentual"
              ? desconto.valor * 100
              : desconto.valor;
        } else {
          this.nomeTipoDesconto = "Percentual";
          this.fator = 0;
        }
      },
      immediate: true,
    },

    visivel(v) {
      if (v) {
        this.$refs.form.resetValidation();
      }
    },
  },
  computed: {
    tipoDesconto() {
      const vm = this;
      return this.tipos.find((t) =>
        vm.nomeTipoDesconto != "SemDesconto"
          ? t.nome === vm.nomeTipoDesconto
          : "SemDesconto"
      );
    },

    valorTotalReativo() {
      return this.valorTotal;
    },

    tipos() {
      let mascaraDinheiro = {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      };
      let mascaraPorcentagem = {
        thousands: ".",
        decimal: ",",
        suffix: " %",
        precision: 1,
        masked: false,
      };
      return [
        {
          nome: "Percentual",
          label: "Descontar por porcentagem",
          labelFator: "Fator",
          regras: [forms.rules.faixa(0.1, 100)],
          mascara: mascaraPorcentagem,
        },
        {
          nome: "Valor",
          label: "Descontar por valor",
          labelFator: "Valor",
          regras: [forms.rules.faixa(0.01, this.valorTotalReativo)],
          mascara: mascaraDinheiro,
        },
        {
          nome: "Final",
          label: "Determinar valor final",
          labelFator: "Valor final",
          regras: [forms.rules.faixa(0.0, this.valorTotalReativo - 0.01)],
          mascara: mascaraDinheiro,
        },
      ];
    },
  },

  methods: {
    validarLimiteDesconto(valorTotal) {
      let limitePercentualDesconto = parseFloat(this.limiteDesconto) / 100;
      let fator = parseFloat(this.fator);

      if (this.nomeTipoDesconto == "Percentual") {
        let percentualDesconto = fator / 100;
        return percentualDesconto <= limitePercentualDesconto ? true : false;
      }

      if (this.nomeTipoDesconto == "Valor") {
        let percentualDesconto = fator / valorTotal;
        return percentualDesconto <= limitePercentualDesconto ? true : false;
      }

      if (this.nomeTipoDesconto == "Final") {
        let percentualDesconto = parseFloat((valorTotal - fator) / valorTotal);
        return percentualDesconto <= limitePercentualDesconto ? true : false;
      }
    },

    async aplicarDesconto() {
      if (this.fator <= 0) return;

      let valorTotal = this.descontoValorTotal
        ? this.valorTotal
        : this.item.valorBruto;
      if (this.validarLimiteDesconto(parseFloat(valorTotal)) == true) {
        if (this.descontoValorTotal) {
          this.$emit("update:desconto", {
            tipo: this.tipoDesconto.nome,
            valor:
              this.tipoDesconto.nome === "Percentual"
                ? this.fator / 100
                : this.fator,
          });
          this.visivel = false;
        }

        if (this.descontoUnitario) {
          this.$emit("update:itemDesconto", {
            tipo: this.tipoDesconto.nome,
            valor:
              this.tipoDesconto.nome === "Percentual"
                ? (this.fator / 100) * this.item.valorBruto
                : this.tipoDesconto.nome === "Final"
                ? valorTotal - this.fator
                : this.fator,
          });
          this.visivel = false;
        }
      } else {
        await alerts.exibirErro(
          "Limite de desconto excedido",
          "O valor inserido no campo excede o valor máximo configurado para desconto"
        );
      }
    },
  },
};
</script>

<style scoped></style>
